import type { CookieEntity } from '~/core/entities/CookieConfig';
import { CookiesService } from '~/services/Cookies';

export const defaultCookieState: CookieEntity = {
  cookiesAccepted: 'pending',
  allowedCategories: [],
};

export const useCookieSate = defineStore('cookieState', {
  state: (): CookieEntity => ({ ...defaultCookieState, allowedCategories: [] }),
  actions: {
    initialize() {
      this.$patch(CookiesService.initialize());
    },

    acceptCookies(category: string[]) {
      this.cookiesAccepted = 'accepted';
      this.allowedCategories = category;
      CookiesService.setCookies(category);
      this.initialize();
    },
    rejectCookies() {
      this.cookiesAccepted = 'rejected';
      this.allowedCategories = [];
      CookiesService.rejectCookies();
    },
  },
});
